import BackendApi from '@/services/backend.service'

export default [
  //WHATSAPP BUSINESS
  {
    path: '/whatsapp/config/account/:senderId?',
    name: 'whatsapp-configuration',
    component: () => import('@/pages/Services/Selector/CampaignConfigurator.vue'),
    props: true
  },
  {
    path: '/whatsapp/config/account/:senderId/templates',
    name: 'whatsapp-template-list',
    component: () => import('@/pages/Services/Selector/CampaignConfigurator/Templates/ServTemplateView.vue'),
    props: true
  },
  {
    path: '/whatsapp/config/templates',
    name: 'whatsapp-template-list-without-sender',
    component: () => import('@/pages/Services/Selector/CampaignConfigurator/Templates/ServTemplateView.vue')
  },
  {
    path: '/whatsapp/config/account/:senderId/flows',
    name: 'whatsapp-flow-list',
    component: () => import('@/pages/Services/Selector/CampaignConfigurator/Flows/ServFlowView.vue'),
    props: true
  },
  {
    path: '/whatsapp/config/flows',
    name: 'whatsapp-flow-list-without-sender',
    component: () => import('@/pages/Services/Selector/CampaignConfigurator/Flows/ServFlowView.vue')
  }
]
